import { createStore, applyMiddleware } from "redux"
import { rootReducer } from "./reducers"
import thunk from "redux-thunk"
import logger from 'redux-logger'

export const makeStore = () => {
    const mw = applyMiddleware(thunk, logger)
    return createStore(rootReducer, mw)
}
